import { render } from "./RescheduleAppointment.vue?vue&type=template&id=b144dda8&ts=true"
import script from "./RescheduleAppointment.vue?vue&type=script&lang=ts"
export * from "./RescheduleAppointment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__